import * as configs from ".";
import { ProductListConfig } from "./config.schema";

type ProductListConfigMap = {
  [name in keyof typeof configs]: ProductListConfig;
};

export type ProductListConfigName = keyof ProductListConfigMap;

export const productListConfigMap: ProductListConfigMap = configs;
